import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';

@Injectable()
export class TreeViewService {
  checkNode(nodes: TreeNode[], selectedData: string[], selectedNode: TreeNode[]): TreeNode[] {
    for (let i = 0; i < nodes.length; i++) {
      if (!nodes[i].leaf && nodes[i].children[0].leaf) {
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedData.includes(nodes[i].children[j].data)) {
            if (!selectedNode.includes(nodes[i].children[j])) {
              selectedNode.push(nodes[i].children[j]);
            }
          }
        }
      }

      if (nodes[i].leaf) {
        return selectedNode;
      } else {
        this.checkNode(nodes[i].children, selectedData, selectedNode);

        const count = nodes[i].children.length;

        let c = 0;

        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedNode.includes(nodes[i].children[j])) {
            c++;
          }
          if (nodes[i].children[j].partialSelected) {
            nodes[i].partialSelected = true;
          }
        }

        if (c === count) {
          nodes[i].partialSelected = false;
          if (!selectedNode.includes(nodes[i])) {
            selectedNode.push(nodes[i]);
          }
        } else if (c !== 0) {
          nodes[i].partialSelected = true;
        }
      }
    }

    return selectedNode;
  }

  checkNodeIndustryClassification(nodes: TreeNode[], selectedData: string[], selectedNode: TreeNode[]): TreeNode[] {
    for (let i = 0; i < nodes.length; i++) {
      if (selectedData.includes(nodes[i].data)) {
        if (!selectedNode.includes(nodes[i])) {
          selectedNode.push(nodes[i]);
        }
      }

      if (!nodes[i].leaf && nodes[i].children[0].leaf) {
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedData.includes(nodes[i].children[j].data)) {
            if (!selectedNode.includes(nodes[i].children[j])) {
              selectedNode.push(nodes[i].children[j]);
            }
          }
        }
      }

      if (!nodes[i].leaf) {
        this.checkNodeIndustryClassification(nodes[i].children, selectedData, selectedNode);
        if (nodes[i].partialSelected) {
          nodes[i].partialSelected = false;
        }
        const childCount = nodes[i].children.length;
        let c = 0;
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedData.includes(nodes[i].children[j].data)) {
            if (!selectedData.includes(nodes[i].data)) {
              nodes[i].partialSelected = true;
            }
          }

          if (nodes[i].children[j].partialSelected) {
            if (!selectedData.includes(nodes[i].data)) {
              nodes[i].partialSelected = true;
            }
          }

          if (selectedData.includes(nodes[i].data)) {
            if (!selectedData.includes(nodes[i].children[j].data) && !nodes[i].children[j].partialSelected) {
              c++;
            }
          }
        }

        if (c === childCount) {
          nodes[i].styleClass = 'onlyparent';
        } else {
          nodes[i].styleClass = '';
        }
      }
    }

    return selectedNode;
  }

  removeNode(node: TreeNode, selectedData: string[]): string[] {
    if (node.leaf) {
      selectedData.splice(selectedData.indexOf(node.data), 1);
      return selectedData;
    }

    for (let i = 0; i < node.children.length; i++) {
      this.removeNode(node.children[i], selectedData);
    }

    return selectedData;
  }

  addNode(node: TreeNode, selectedData: string[]): string[] {
    if (node.leaf) {
      if (!selectedData.includes(node.data)) {
        selectedData.push(node.data);
      }
      return selectedData;
    }

    for (let i = 0; i < node.children.length; i++) {
      this.addNode(node.children[i], selectedData);
    }
    return selectedData;
  }

  addNodeIndustryClassification(node: TreeNode, selectedData: string[], selectedLabel: TreeNode[]): string[] {
    if (node.leaf) {
      if (!selectedData.includes(node.data)) {
        selectedData.push(node.data);
      }

      if (selectedLabel.findIndex((a) => a.data === node.data) === -1) {
        selectedLabel.push({ label: node.label, data: node.data });
      }
      return selectedData;
    }

    for (let i = 0; i < node.children.length; i++) {
      this.addNodeIndustryClassification(node.children[i], selectedData, selectedLabel);
    }
    return selectedData;
  }

  checkNodeForUnSelect(nodes: TreeNode[], selectedData: string[], selectedNode: TreeNode[], isUnSelectedFromSelection = false): TreeNode[] {
    for (let i = 0; i < nodes.length; i++) {
      if (!nodes[i].leaf && nodes[i].children[0].leaf) {
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedData.includes(nodes[i].children[j].data)) {
            if (!selectedNode.includes(nodes[i].children[j])) {
              selectedNode.push(nodes[i].children[j]);
            }
          }
        }
      }

      if (nodes[i].leaf) {
        if (selectedData.includes(nodes[i].data)) {
          if (!selectedNode.includes(nodes[i])) {
            selectedNode.push(nodes[i]);
          }
        }
      } else {
        this.checkNodeForUnSelect(nodes[i].children, selectedData, selectedNode, isUnSelectedFromSelection);

        const count = nodes[i].children.length;
        const chckChild: TreeNode[] = [];
        let c = 0;
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedNode.includes(nodes[i].children[j])) {
            c++;
          } else {
            if (!chckChild.includes(nodes[i])) {
              chckChild.push(nodes[i]);
            }
          }
          if (nodes[i].children[j].partialSelected) {
            nodes[i].partialSelected = true;
          }
        }

        if (c === 0 && isUnSelectedFromSelection === true) {
          chckChild.forEach((val) => {
            if (val.children && val.children.length > 0) {
              if (val.children.findIndex((child) => child.partialSelected === true && child.leaf === false) === -1) {
                val.partialSelected = false;
              }
            } else if (c !== 0 || isUnSelectedFromSelection === true) {
              val.partialSelected = false;
            }
          });
        } else if (c === count) {
          nodes[i].partialSelected = false;
          if (!selectedNode.includes(nodes[i])) {
            selectedNode.push(nodes[i]);
          }
        } else {
          nodes[i].partialSelected = true;
        }

        if (selectedNode.length == 0) {
          if (nodes[i].partialSelected) {
            nodes[i].partialSelected = false;
          }
        }
      }
    }

    return selectedNode;
  }

  //Used for location
  checkNodeLocationUnSelect(nodes: TreeNode[], selectedData: string[], selectedNode: TreeNode[]): TreeNode[] {
    for (let i = 0; i < nodes.length; i++) {
      if (!nodes[i].leaf && nodes[i].children[0].leaf) {
        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedData.includes(nodes[i].children[j].data)) {
            if (!selectedNode.includes(nodes[i].children[j])) {
              selectedNode.push(nodes[i].children[j]);
            }
          }
        }
      }

      if (nodes[i].leaf) {
        return selectedNode;
      } else {
        this.checkNodeLocationUnSelect(nodes[i].children, selectedData, selectedNode);

        const count = nodes[i].children.length;

        let c = 0;

        for (let j = 0; j < nodes[i].children.length; j++) {
          if (selectedNode.includes(nodes[i].children[j])) {
            c++;
          }
          if (nodes[i].children[j].partialSelected) {
            nodes[i].partialSelected = true;
          }
        }

        if (c === 0) {
          const a = nodes[i];
          // let index = a.children.findIndex(c => c.partialSelected == true);

          if (!a.leaf && a.children.findIndex((child) => child.partialSelected === true) !== 0) {
            a.partialSelected = false;
          }
        } else if (c === count) {
          nodes[i].partialSelected = false;
          if (!selectedNode.includes(nodes[i])) {
            selectedNode.push(nodes[i]);
          }
        } else {
          nodes[i].partialSelected = true;
        }
      }
    }

    return selectedNode;
  }
}
